import type { Route } from '@application/types';

export const BUYER_APPLICATIONS_ALERT_EXCLUDED_ROUTES: Route[] = [
  'mtLanding',
  'mtMessages',
  'mtApplicationCheckoutSuccess',
  'mtPuppyGuide',
  'mtContact',
];
